import { http, pagination } from 'utils'
import { make } from 'vuex-pathify'

export default {
  namespaced: true,

  state: {
    stations: [],
    meta: null
  },

  actions: {
    ...make.actions('stations'),
    ...make.actions('meta'),

    async getPendingStations ({ dispatch, state }, { fresh = false, params = {} } = {}) {
      if (state.meta) {
        if (pagination(state.meta) && fresh === false) {
          return Promise.reject(new Error('No more results.'))
        }
        params.page = state.meta.current_page + 1
      }

      if (fresh) {
        params.page = 1
      }

      const response = await http.get('/delivery-runs/pending-stations', { params })

      if (params.page === 1 || params.page === undefined) {
        dispatch('setStations', response.data.data)
      } else {
        dispatch('setStations', [...state.stations, ...response.data.data])
      }

      dispatch('setMeta', response.data.meta)

      return response
    }
  },

  mutations: {
    ...make.mutations('stations'),
    ...make.mutations('meta')
  }
}
